// import TicketMenuManagementCreate from "./lib/create";
import CategorieyDetailForm from '../lib/form';
import Gap from 'components/gap';
// import { useTypedSelector } from "common/hooks/useTypedSelector";
import AppLoading from 'components/appLoading';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function CategoryDetailPage() {
  const { ticketCategory, supporterList, ticketCategoryDetail, ticketCategoryIcon, ticketCategoryEdit } =
    useTypedSelector((state: any) => state.Tickets);
  const { supporter } = useTypedSelector((state: any) => state.Admin);

  return (
    <S.Container>
      <S.Head>
        <PageTitle
          title={ticketCategoryDetail.data?.title ? `Category ${ticketCategoryDetail.data.title}` : 'Category'}
        />
      </S.Head>
      <Gap size="20px" />
      <S.Div className="row">
        <S.Div className="col-12">
          <CategorieyDetailForm
            categories={ticketCategory.data}
            supporterList={supporterList}
            supporter={supporter.data}
            data={ticketCategoryDetail.data}
          />
        </S.Div>
        {/* <S.Div className="col-md-6">
          <CategorySupporterTable data={supporterList} />
        </S.Div> */}
      </S.Div>

      <AppLoading
        loading={
          ticketCategoryDetail.loading || ticketCategoryIcon.loading || ticketCategoryEdit.loading || supporter.loading
        }
      />
    </S.Container>
  );
}
